<template>
  <span class="shape-picker__layered-icon" aria-hidden="true">
    <img v-for="state in states" :key="state" :data-icon-state="state" :src="`/new-studio/shapes/layered-engraved/${pattern}${state === 'default' ? '' : `-${state}`}.svg`" alt="" />
  </span>
</template>

<script setup lang="ts">
defineProps<{ pattern: string }>()
const states = ['default', 'hover', 'selected', 'disabled'] as const
</script>

<style scoped>
.shape-picker__layered-icon { display: block; position: relative; width: 100%; height: 100%; flex: none; }
img { position: absolute; top: 0; left: 0; width: 100%; height: 100%; max-width: none; }
img:not([data-icon-state="default"]) { visibility: hidden; }
</style>
